import Button from "../../../../../../components/elements/Button/Button";
import {useIntl} from "react-intl";
import React, {useEffect, useState} from "react";
import {useNavigate, useOutletContext, useParams} from "react-router-dom";
import {toast} from "react-toastify";
import axios from "axios";
import errorParser from "../../../../../../components/ErrorParser/ErrorParser";
import LoadingComp from "../../../../../../components/elements/LoadingComp/LoadingComp";
import AddFoodMenuForm from "../../../../Nomenclature/Menus/FoodMenus/AddFoodMenuForm";

export default function EditCustomFoodMenu() {

    const intl = useIntl();
    const navigate = useNavigate()
    let params = useParams();
    const jwt = localStorage.getItem('jwt')

    const [title, setTitle] = useState('')
    const [price, setPrice] = useState(0)
    const [cost, setCost] = useState(0)
    const [addition, setAddition] = useState(0)
    const [items, setItems] = useState([])
    const [costPerMenu, setCostPerMenu] = useState(false)
    const [pricePerMenu, setPricePerMenu] = useState(false)
    const [vat, setVat] = useState(0)
    const [vats, setVats] = useState([])
    const [productsOptions, setProductsOptions] = useState([])

    const [loading, setLoading] = useState(true)

    const [saveLoading, setSaveLoading] = useState(false)
    const {context} = useOutletContext()

    useEffect(() => {
        getData()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const getData = async () => {
        axios.get(process.env.REACT_APP_API + '/food-menus/' + params.id_menu, {
            headers: {
                'Authorization': 'Bearer ' + jwt
            }
        })
            .then(async (response) => {
                if (response.data) {
                    setTitle(response.data.title)
                    setCost(response.data.cost)
                    setCostPerMenu(response.data.cost_per_menu)
                    setPricePerMenu(response.data.price_per_menu)
                    setAddition(parseFloat(100 * (response.data.price - response.data.cost)/response.data.cost).toFixed(2))
                    setPrice(response.data.price)
                    setVat(response.data.vat)
                    setItems(response.data.items)

                    getVats()
                }
            })
            .catch(err => {
                errorParser(err, intl)
            })
    }


    const getVats = async () => {
        axios.get(process.env.REACT_APP_API + '/vats', {
            headers: {
                'Authorization': 'Bearer ' + jwt
            }
        })
            .then(async (response) => {
                let options = []
                response.data.forEach((item) => {
                    options.push({
                        value: item.id,
                        label: item.value,
                    })
                })
                setVats(options)
                getProductsOptions()
            })
            .catch(err => {
                errorParser(err, intl)
            })
    }

    const getProductsOptions = async () => {
        axios.post(process.env.REACT_APP_API + '/menu-products/list/0', {},{
            headers: {
                'Authorization': 'Bearer ' + jwt
            }
        })
            .then(async (response) => {
                let options = []
                response.data.products.filter(item => item.type !== 'ingredients' && item.category === 'food').forEach((item) => {
                    options.push({
                        value: item.id,
                        label: item.title,
                        price: item.price,
                        cost: item.production_price,
                        unit: item.unit,
                    })
                })
                setProductsOptions(options)
                setLoading(false)
            })
            .catch(err => {
                errorParser(err, intl)
            })
    }
    const save = async (e) => {
        e.preventDefault();
        if (vat === 0) {
            toast.error(intl.formatMessage({id: "errors.please_fill_all_fields"}))
            return
        }
        setSaveLoading(true)

        let payload = {
            title: title,
            price: price,
            cost,
            items: items,
            vat,
            cost_per_menu: costPerMenu,
            price_per_menu: pricePerMenu,
        }
        await axios.put(process.env.REACT_APP_API + '/food-menus/' + params.id_menu, payload, {
            headers: {
                'Authorization': 'Bearer ' + jwt
            }
        })
            .then(async (response) => {
                toast.success(intl.formatMessage({id: 'errors.success.data_has_been_saved'}))
                context.setContentUpdated(false)
                navigate(-1)
            })
            .catch(err => {
                errorParser(err, intl)
            })


        setSaveLoading(false)
    }

    if (loading) {
        return <LoadingComp/>
    }

    return (
        <div className="card">

            <div className={"header"}><p>{intl.formatMessage({id: 'menus.edit_food_menu'})}</p></div>

            <form onSubmit={(e) => save(e)}>
                <div className={"content"}>
                    <AddFoodMenuForm
                        cost={cost}
                        setCost={setCost}
                        items={items}
                        setItems={setItems}
                        price={price}
                        setPrice={setPrice}
                        title={title}
                        setTitle={setTitle}
                        vat={vat}
                        setVat={setVat}
                        showEventType={false}
                        context={context}
                        addition={addition}
                        setAddition={setAddition}
                        costPerMenu={costPerMenu}
                        setCostPerMenu={setCostPerMenu}
                        pricePerMenu={pricePerMenu}
                        setPricePerMenu={setPricePerMenu}
                        vats={vats}
                        productsOptions={productsOptions}
                    />
                </div>

                <div className={"footer"}>
                    <div className={"row"}>
                        <div className={"col-12 col-md-6"}>
                            <Button
                                className={"btn-light mt-2"}
                                icon={"fa-solid fa-chevron-left"}
                                value={intl.formatMessage({id: 'general.buttons.back'})}
                                onClick={() => {
                                    context.setLeavePage(true)
                                    context.setNextLink('/events/'+params.id+'/food-menu')
                                }}
                            />
                        </div>
                        <div className={"col-12 col-md-6 d-flex"}>
                            <Button
                                className={"btn-secondary mt-2 ms-auto"}
                                icon={"fa-regular fa-floppy-disk"}
                                value={intl.formatMessage({id: 'general.buttons.save'})}
                                disabled={saveLoading}
                                loading={saveLoading}
                                type={'submit'}
                            />
                        </div>
                    </div>
                </div>
            </form>
        </div>
    );
}

